export const BREADCRUMBS = {
  CONTENT_OFFSET : 16,
  TOOLTIP_DISTANCE : 1
};